import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import OrderPage from './orders';
import { PageWithNavigation } from '../../components';
/**
 * Orders Page RefundPage
 */
export default () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <>
      <Helmet>
        <title>Orders</title>
      </Helmet>
      <PageWithNavigation>
        <OrderPage
          t={t}
          useSelector={useSelector}
          history={history}
          dispatch={dispatch}
          isOffline
        />
      </PageWithNavigation>
    </>
  );
};
